function getBaseUrl() {
  // this URL has to be the same as `ajax_url` in settings_data.json
  const url = 'https://servizi.caffitaly.com/customer'
  return url;
}

function registerHandleCF(elemId, errorDiv, errorClass) {
  const url = getBaseUrl() + '/checkcf'
  bindFiscalDataCheckEvents(url, elemId, errorDiv, errorClass);
}

function registerHandlePIVA(elemId, errorDiv, errorClass) {
  const url = getBaseUrl() + '/checkpiva'
  bindFiscalDataCheckEvents(url, elemId, errorDiv, errorClass);
}


function bindFiscalDataCheckEvents(wsUrl, inputId, errorDivSelector, errorClass) {
  var inputField = $(inputId)
  var errorDiv = (errorDivSelector != null) ? $(errorDivSelector) : null;

  inputField.on('keyup', function () {
    inputField.removeClass(errorClass);
  })

  inputField.on('blur', function () {
    if (inputField.val() != '') {
      checkFiscalData(wsUrl, inputField, errorDiv, errorClass);
    } else {
      if (inputField.attr('aria-required') == 'true' && errorDivSelector != null) {
        console.log("campo obbligatorio");
        inputField.addClass(errorClass);
        errorDiv.find(">:first-child").text("Campo obbligatorio.");
        errorDiv.show();
        inputField.attr('aria-invalid', 'true');
        checkDisableSubmit(inputField);
      }
    }
  });
}

function checkFiscalData(url, inputField, errorDiv, errorClass) {
  var value = inputField.val();
  var imgLoader = "#img-load-" + inputField.attr("id");
  $(imgLoader).show();

  $.get(url, { input: value }, 'jsonp')
    .done(function () {
      inputField.removeClass(errorClass);
      inputField.attr('aria-invalid', 'false');
      errorDiv.find(">:first-child").text("");
      errorDiv.hide();
      inputField.get(0).setCustomValidity('');
      // enable submit button
      checkDisableSubmit(inputField);
    })
    .fail(function (xhr) {
      inputField.addClass(errorClass);
      var errorText = xhr.responseText;
      if (errorText === "" || errorText === undefined) {
        errorText = "Errore nella procedura di validazione."
      }
      errorDiv.find(">:first-child").text(errorText);
      errorDiv.show();
      inputField.attr('aria-invalid', 'true');
      inputField.get(0).setCustomValidity(errorText);

      // disable submit button
      checkDisableSubmit(inputField);
    })
    .always(function () {
      $(imgLoader).hide();
    });
}

function checkDisableSubmit(inputField) {
  var form = inputField.closest('form');
  var disableSubmit = form.find('input.input--error').length > 0;
  form.find('input[type="submit"]').prop('disabled', disableSubmit);
}

function checkUniqueId(uniqueId) {
  const url = getBaseUrl() + "/checkuniqueid";
  $.get({
    url: url,
    data: {
      uid: uniqueId
    }
  })
  .done(function(response){
    $('#registerTitle').text('Registrazione dipendente Caffitaly');
  })
  .fail(function(err){
    console.log('[ERROR] Invalid unique id: ' + err.responseText);
    $('#uniqueIdError').removeAttr('hidden');
  });
}